import React from "react"

import { Form, Input, Label, Row, Col, FormFeedback } from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import { useStoreAdditionalDetailsProfileMutation } from "store/api/profile/profile.api"
import { useSelector } from "react-redux"

const genderOptions = [
  {
    key: "M",
    label: "Male",
  },
  {
    key: "F",
    label: "Female",
  },
  {
    key: "O",
    label: "Other",
  },
]

const occupation = [
  "Business",
  "Service",
  "Professional",
  "Retired",
  "Others, please specify",
]

const residentialStatus = [
  "Resident Indian",
  "Non-Resident Indian",
  "Others, please specify",
]

const nationality = ["Select", "Indian"]

const maritalStatusOptions = ["Married", "Single", "Other"]

const politicalExposeOptions = [
  "Not Applicable",
  "Politically Exposed Person",
  "Related to Politically Exposed Person",
]

const AdditionalDetails = ({ kycData }) => {
  const [mutate, { isLoading }] = useStoreAdditionalDetailsProfileMutation()
  const { userType } = useSelector((state) => state.user)

  const storeDetails = async (body) => {
    try {
      const { success, message } = await mutate({
        ...body,
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      father_name: kycData?.investorsAadhaar?.father_name,
      gender: kycData?.investorsAadhaar?.gender,
      occupation: kycData?.additionalDetails?.occupation,
      specifyOccupation: kycData?.additionalDetails?.specifyOccupation,
      residentialStatus: kycData?.additionalDetails?.residentialStatus,
      specifyResidentialStatus:
        kycData?.additionalDetails?.specifyResidentialStatus,
      nationality: "Indian",
      maritalStatus: kycData?.additionalDetails?.maritalStatus,
      politicalExposure: kycData?.additionalDetails?.politicalExposure,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      storeDetails(values)
    },
  })

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Additional Details</h5>
        <p>
          These details are required for registration of an{" "}
          {userType === "INVESTOR" ? "investor" : "wealth partner"}
        </p>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row className="mb-2">
            <Col xl={12}>
              <Label className="col-form-label">
                Father’s Name <span className="error">*</span>
              </Label>
              <Input
                name="father_name"
                type="text"
                className="form-control"
                id="horizontal-firstname-Input"
                placeholder={`Enter father’s name`}
                value={validation.values.father_name}
                onChange={validation.handleChange}
                invalid={
                  validation.touched.father_name &&
                  validation.errors.father_name
                }
              />

              {validation.touched.father_name &&
              validation.errors.father_name ? (
                <FormFeedback type="invalid">
                  {validation.errors.father_name}
                </FormFeedback>
              ) : null}
            </Col>

            <Col xl={12}>
              <Label className="col-form-label">
                Gender <span className="error">*</span>
              </Label>
              <select
                id="gender"
                name="gender"
                className={`form-select pageSize ${
                  validation.touched.gender &&
                  validation.errors.gender &&
                  "is-invalid"
                }`}
                value={validation.values.gender}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {genderOptions.map((item, index) => (
                  <option key={`gender_${index}`} value={item.key}>
                    {item.label}
                  </option>
                ))}
              </select>
              {validation.touched.gender && validation.errors.gender ? (
                <FormFeedback type="invalid">
                  {validation.errors.gender}
                </FormFeedback>
              ) : null}
            </Col>
            <Col xl={12}>
              <Label className="col-form-label">
                Occupation <span className="error">*</span>
              </Label>
              <select
                id="occupation"
                name="occupation"
                className={`form-select pageSize ${
                  validation.touched.occupation &&
                  validation.errors.occupation &&
                  "is-invalid"
                }`}
                value={validation.values.occupation}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {occupation.map((item, index) => (
                  <option key={`occupation_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.occupation && validation.errors.occupation ? (
                <FormFeedback type="invalid">
                  {validation.errors.occupation}
                </FormFeedback>
              ) : null}
            </Col>

            {validation.values.occupation === "Others, please specify" && (
              <Col xl={12}>
                <Label className="col-form-label">
                  Specify Occupation <span className="error">*</span>
                </Label>
                <Input
                  name="specifyOccupation"
                  type="text"
                  className="form-control"
                  id="horizontal-firstname-Input"
                  placeholder={`Specify Occupation`}
                  value={validation.values.specifyOccupation}
                  onChange={validation.handleChange}
                  invalid={
                    validation.touched.specifyOccupation &&
                    validation.errors.specifyOccupation
                  }
                />

                {validation.touched.specifyOccupation &&
                validation.errors.specifyOccupation ? (
                  <FormFeedback type="invalid">
                    {validation.errors.specifyOccupation}
                  </FormFeedback>
                ) : null}
              </Col>
            )}
            <Col xl={12}>
              <Label className="col-form-label">
                Residential Status <span className="error">*</span>
              </Label>
              <select
                id="residentialStatus"
                name="residentialStatus"
                className={`form-select pageSize ${
                  validation.touched.residentialStatus &&
                  validation.errors.residentialStatus &&
                  "is-invalid"
                }`}
                value={validation.values.residentialStatus}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {residentialStatus.map((item, index) => (
                  <option key={`residential_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.residentialStatus &&
              validation.errors.residentialStatus ? (
                <FormFeedback type="invalid">
                  {validation.errors.residentialStatus}
                </FormFeedback>
              ) : null}
            </Col>
            {validation.values.residentialStatus ===
              "Others, please specify" && (
              <Col xl={12}>
                <Label className="col-form-label">
                  Specify Residential Status <span className="error">*</span>
                </Label>
                <Input
                  name="specifyResidentialStatus"
                  type="text"
                  className="form-control"
                  id="horizontal-firstname-Input"
                  placeholder={`Specify Residential Status`}
                  value={validation.values.specifyResidentialStatus}
                  onChange={validation.handleChange}
                  invalid={
                    validation.touched.specifyResidentialStatus &&
                    validation.errors.specifyResidentialStatus
                  }
                />

                {validation.touched.specifyResidentialStatus &&
                validation.errors.specifyResidentialStatus ? (
                  <FormFeedback type="invalid">
                    {validation.errors.specifyResidentialStatus}
                  </FormFeedback>
                ) : null}
              </Col>
            )}
            <Col xl={12}>
              <Label className="col-form-label">
                Nationality <span className="error">*</span>
              </Label>
              <select
                disabled
                id="nationality"
                name="nationality"
                className={`form-select pageSize ${
                  validation.touched.nationality &&
                  validation.errors.nationality &&
                  "is-invalid"
                }`}
                value={validation.values.nationality}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {nationality.map((item, index) => (
                  <option value={item} key={`nationality_${index}`}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.nationality &&
              validation.errors.nationality ? (
                <FormFeedback type="invalid">
                  {validation.errors.nationality}
                </FormFeedback>
              ) : null}
            </Col>
            <Col xl={12}>
              <Label className="col-form-label">
                Marital Status <span className="error">*</span>
              </Label>
              <select
                id="maritalStatus"
                name="maritalStatus"
                className={`form-select pageSize ${
                  validation.touched.maritalStatus &&
                  validation.errors.maritalStatus &&
                  "is-invalid"
                }`}
                value={validation.values.maritalStatus}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {maritalStatusOptions.map((item, index) => (
                  <option key={`marital_status_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.maritalStatus &&
              validation.errors.maritalStatus ? (
                <FormFeedback type="invalid">
                  {validation.errors.maritalStatus}
                </FormFeedback>
              ) : null}
            </Col>
            <Col xl={12}>
              <Label className="col-form-label">
                Political Exposure <span className="error">*</span>
              </Label>
              <select
                id="politicalExposure"
                name="politicalExposure"
                className={`form-select pageSize ${
                  validation.touched.politicalExposure &&
                  validation.errors.politicalExposure &&
                  "is-invalid"
                }`}
                value={validation.values.politicalExposure}
                onChange={validation.handleChange}
              >
                <option value="">Select</option>
                {politicalExposeOptions.map((item, index) => (
                  <option key={`political_exposure_${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              {validation.touched.politicalExposure &&
              validation.errors.politicalExposure ? (
                <FormFeedback type="invalid">
                  {validation.errors.politicalExposure}
                </FormFeedback>
              ) : null}
            </Col>
            <Col sm={12}>
              <div className="d-flex align-items-center mt-4">
                <button type="submit" className="btn btn-primary w-100">
                  {isLoading ? <Spinners /> : "Proceed"}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  )
}

export default AdditionalDetails
